import { handleJSON, stringifyEncodeParams } from '@/utils/fetch-utils';
import { headers } from './index';

const { API_URL } = process.env;

export default {
  endpoints: {
    overview: `${API_URL}/organization-overview-report/`,
    proficiency: `${API_URL}/organization-proficiency-report/`,
    unitDetailReport: `${API_URL}/unit-detail-report/`,
    courseDetailReport: `${API_URL}/course-detail-report/`,
    groupClassesReport: `${API_URL}/group-class-report/`,
    privateClassesReport: `${API_URL}/private-class-report/`,
    vpaReport: `${API_URL}/vpa-report/`,
    lessonHistoryReport: `${API_URL}/user-lessons-history/`,
    sessionReport: `${API_URL}/session-report/`,
    k12SchoolEnrollmentReport: `${API_URL}/k12-school-enrollment-report/`,
    k12TeacherEnrollmentReport: `${API_URL}/k12-teacher-enrollment-report/`,
  },

  fetchReport(url, { format = 'json', callback = handleJSON, ...params }) {
    const endpoint = `${url}${stringifyEncodeParams({ ...params, format })}`;
    const customHeaders = headers();

    if (format === 'csv') {
      customHeaders.Accept = 'text/csv';
    } else if (format === 'xlsx') {
      customHeaders.Accept = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
    }

    const options = {
      method: 'GET',
      headers: customHeaders,
    };

    return fetch(endpoint, options).then(callback);
  },

  fetchOrganizationOverview({ organizationId, filters, callback = handleJSON }) {
    const options = {
      method: 'GET',
      headers: headers(),
    };

    const filterParams = Object.keys(filters)
      .map(key => ({
        key: filters[key].key,
        value: filters[key].value,
      }))
      .filter(param => param.value);

    let params = [{ key: 'organization_id', value: organizationId }, ...filterParams];

    const urlBase = this.endpoints.overview;

    params = params.map(param => `${param.key}=${param.value}`);

    const paramsQuery = params.join('&');
    const endpoint = `${urlBase}?${paramsQuery}`;

    return fetch(endpoint, options).then(callback);
  },

  fetchOrganizationProficiency({ organizationId, filters, callback = handleJSON }) {
    const options = {
      method: 'GET',
      headers: headers(),
    };

    const filterParams = Object.keys(filters)
      .map(key => ({
        key: filters[key].key,
        value: filters[key].value,
      }))
      .filter(param => param.value);

    let params = [{ key: 'organization_id', value: organizationId }, ...filterParams];

    const urlBase = this.endpoints.proficiency;

    params = params.map(param => `${param.key}=${param.value}`);
    const paramsQuery = params.join('&');
    const endpoint = `${urlBase}?${paramsQuery}`;

    return fetch(endpoint, options).then(callback);
  },

  fetchGroupClassesReport(params) {
    const url = this.endpoints.groupClassesReport;
    return this.fetchReport(url, params);
  },

  fetchPrivateClassesReport(params) {
    const url = this.endpoints.privateClassesReport;
    return this.fetchReport(url, params);
  },

  fetchUnitsReport(params) {
    const url = this.endpoints.unitDetailReport;
    return this.fetchReport(url, params);
  },

  fetchCoursesReport(params) {
    const url = this.endpoints.courseDetailReport;
    return this.fetchReport(url, params);
  },

  fetchVpaReport(params) {
    const url = this.endpoints.vpaReport;
    return this.fetchReport(url, params);
  },

  fetchLessonHistoryReport(params) {
    const url = this.endpoints.lessonHistoryReport;
    return this.fetchReport(url, params);
  },

  fetchSessionReport(params) {
    const url = this.endpoints.sessionReport;
    return this.fetchReport(url, params);
  },

  fetchK12SchoolEnrollmentReport(params) {
    return this.fetchReport(this.endpoints.k12SchoolEnrollmentReport, params);
  },

  fetchK12TeacherEnrollmentReport(params) {
    return this.fetchReport(this.endpoints.k12TeacherEnrollmentReport, params);
  },
};
